module.exports = __webpack_public_path__ + "img/sld_mfm_battery_2_t1_b1_dark.e78273b2.svg";